const formatPrice = (price) => {
  return typeof price === 'number' ? `$${price.toFixed(2)}` : price
}

export default formatPrice
